import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
  @Output() showDPO = new EventEmitter();

  readonly year = new Date().getFullYear();

  onClickDPO() {
    this.showDPO.emit();
  }
}
